import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import "./ProjectDetails.css";
import status from "./../assets/status.svg";
import mapIcon from "./../assets/close.svg";
import PaymentHandler from "./PaymentHandler";

const ProjectDetails = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [plotData, setPlotData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [plotStatus, setPlotStatus] = useState("Loading...");
  const [showPricePopup, setShowPricePopup] = useState(false);

  // Fetch plot data from Firestore
  useEffect(() => {
    const fetchPlotData = async () => {
      try {
        const plotRef = doc(db, "essennplots", projectId);
        const plotSnap = await getDoc(plotRef);

        if (plotSnap.exists()) {
          const selectedPlot = { projectId: plotSnap.id, ...plotSnap.data() };
          setPlotData({
            id: selectedPlot.projectId,
            blockName: selectedPlot.blockName,
            projectName: selectedPlot.projectName || "Not Specified",
            plotName: selectedPlot.plotNumber,
            surveyNumber: selectedPlot.surveyNumber,
            areaSqMt: selectedPlot.areaSqMt,
            areaSqFt: selectedPlot.areaSqFt,
            eastWestMt: selectedPlot.eastWestMt,
            northSouthMt: selectedPlot.northSouthMt,
            facing: selectedPlot.facing,
            corner: selectedPlot.corner,
            parkFacing: selectedPlot.parkFacing,
            surveyDocumentLink : selectedPlot.surveyDocumentLink,

          });
          setSelectedPlot(selectedPlot.projectId);
          setPlotStatus(selectedPlot.Status || "Not Available");
        } else {
          setPlotData({
            id: projectId,
            plotName: `Plot ${projectId.split("-")[1]} (Data Not Available)`,
          });
          setPlotStatus("Not Available");
        }
      } catch (error) {
        console.error("Error fetching plot data from Firestore:", error);
        setPlotData({
          id: projectId,
          plotName: `Plot ${projectId.split("-")[1]} (Data Not Available)`,
        });
        setPlotStatus("Error");
      } finally {
        setLoading(false);
      }
    };

    fetchPlotData();
  }, [projectId]);

  const closePopup = () => {
    setSelectedPlot(null);
    navigate("/booking");
  };

  const handlePriceTableClick = () => {
    setShowPricePopup(true);
  };

  const closePricePopup = () => {
    setShowPricePopup(false);
  };

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case "sold":
        return "status-sold";
      case "booked":
        return "status-booked";
      case "available":
        return "status-available";
      default:
        return "status-default";
    }
  };

  if (loading) {
    return (
      <div
        className="project-details-container"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
      >
        <div style={{ backgroundColor: '#ffffff', borderRadius: '25px', padding: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <div
          style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #024837',
            borderRadius: '50%',
            width: '25px',
            height: '25px',
            animation: 'spin 1s linear infinite',
            marginBottom: '10px'
          }}
        ></div>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', color: '#333' }}>Loading...</span>
      </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div className="project-details-container">
      {selectedPlot && plotData ? (
        <div className="plot-details-popup" onClick={closePopup}>
          <div className="plot-details-popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="header-row">
             
              <span className="facing">Silver kites-Luxus</span>
            </div>
            <div className="popup-columns">
              <div className="column column-plot-number">
                <div className="plot-number-box">{plotData.plotName}</div>
                <div className={`status-bar ${getStatusClass(plotStatus)}`}>
                  <span>
                    <img src={status} className="status-icon" alt="status" />
                    Status: {plotStatus}
                  </span>
                </div>
              </div>
              <div className="column column-details column-detailss">
                
                <div className="detail-card">
                  Survey Number
                  <span className="detail-value">{plotData.surveyNumber}</span>
                </div>
                <div className="detail-card">
                  Area in Sq. Ft
                  <span className="detail-value">{plotData.areaSqFt}</span>
                </div>
                <div className="detail-card">
                  Area in Sq. Mt
                  <span className="detail-value">{plotData.areaSqMt}</span>
                </div>
                <div className="detail-card">
                  East-West
                  <span className="detail-value">{plotData.eastWestMt} m</span>
                 
                </div >
                <div className="detail-card">
                   North-South
                  <span className="detail-value">{plotData.northSouthMt} m</span>
                </div>

           
              </div>
              <div className="column column-details">
                <div className="detail-card">
                  Facing
                  <span className="detail-value">{plotData.facing}</span>
                </div>
                <div className="detail-card">
                  Park Facing
                  <span className="detail-value">{plotData.parkFacing}</span>
                </div>
                <div className="detail-card">
                 Corner
                  <span className="detail-value">{plotData.corner}</span>
                </div>
                
                {/* Price Table Button */}
                <button 
                  className="price-table-button"
                  onClick={handlePriceTableClick}
                  disabled={plotStatus.toLowerCase() === 'sold'}
                >
                  ₹ Price Table
                </button>
              </div>
            </div>
            <div className="footer-row">
              <PaymentHandler
                plotData={plotData}
                plotStatus={plotStatus}
                projectId={projectId}
                setPlotStatus={setPlotStatus}
                closeParentPopup={closePopup}
              /> 
              <div className="home-button" onClick={closePopup}>
                <img
                  src={mapIcon}
                  alt="Close"
                  style={{ width: "60px", height: "60px", marginRight: "20px" }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No detailed data available for this plot.</div>
      )}

      {/* Price Popup */}
      {showPricePopup && (
        <div className="price-popup-overlay" onClick={closePricePopup}>
          <div className="price-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-popup-button" onClick={closePricePopup}>
              ✕
            </button>
            <div className="price-table-container">
              <h2>Pricing Details</h2>
              <table>
                <thead>
                  <tr>
                    <th>Plot Size (sq.ft.)</th>
                    <th>Price Range (₹ Lakhs)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1200</td>
                    <td>31.1 - 33.5</td>
                  </tr>
                  <tr>
                    <td>1500</td>
                    <td>38.9 - 41.98</td>
                  </tr>
                  <tr>
                    <td>2400</td>
                    <td>62.3 - 67.1</td>
                  </tr>
                </tbody>
              </table>
              <p><span style={{ color: 'red' }}>⮚</span> The detailed cost sheet will be shared on the day of the launch.</p>
              <p><span style={{ color: 'red' }}>⮚</span>The first 50 customers will be rewarded with a special exclusive offer.</p>
              <p style={{fontSize:'12px', fontWeight:'bold'}}>Note: PLC, clubhouse charges, infrastructure charges, legal charges, along with GST & registration, will be applicable extra.</p>
              <p style={{fontSize:'12px'}}>@ Essen Infra Township Pvt Ltd.</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;

